import {AppError} from "../core/AppError";
import {actionToastrWarning, actionUserLogout} from "../store/global";

export class ErrorService {

	static handleError (error: AppError) {
		console.log(error)
		if (error.id == 5) actionUserLogout()
		else if (error.id == 10 ) actionToastrWarning("Greška", "Unešeni delovodni broj već postoji")
		else if (error.id == 11 ) actionToastrWarning("Greška", "Unešeni delovodni broj je manji od minimalnog za izabrani datum")
		else {
			actionToastrWarning("Greška pri pozivanju servera", error.message)
		}
	}
}
